export const NEWS_LETTER_SUBSCRIPTIONRESET_STATE = 'NEWS_LETTER_SUBSCRIPTIONRESET_STATE';
export const NEWS_LETTER_SUBSCRIPTIONCURRENT_ITEM = 'NEWS_LETTER_SUBSCRIPTIONCURRENT_ITEM';
 
export const NEWS_LETTER_SUBSCRIPTIONREQUEST_LOADING = 'NEWS_LETTER_SUBSCRIPTIONREQUEST_LOADING';
export const NEWS_LETTER_SUBSCRIPTIONREQUEST_SUCCESS = 'NEWS_LETTER_SUBSCRIPTIONREQUEST_SUCCESS';
export const NEWS_LETTER_SUBSCRIPTIONREQUEST_FAILED = 'NEWS_LETTER_SUBSCRIPTIONREQUEST_FAILED';
 
export const NEWS_LETTER_SUBSCRIPTIONCURRENT_ACTION = 'NEWS_LETTER_SUBSCRIPTIONCURRENT_ACTION';
export const NEWS_LETTER_SUBSCRIPTIONRESET_ACTION = 'NEWS_LETTER_SUBSCRIPTIONRESET_ACTION';